import React,{useState, useEffect} from 'react';
import './job.css'
import {useDispatch , useSelector} from 'react-redux';
import { selectUsername } from "./../../userSlice"

function Job({jobid}) {
  
  const job = jobid?._document?.data?.value?.mapValue?.fields;
  
  const languages = ["Java", "C","C++","Python"]
  const languages_icon = ["images/java.png", "images/c.png","images/c++.png","images/python.png"]
  const web = ["Html","Css","Javascript","React","Angular","Node js","Vue.Js","PHP","Ruby on Rails"]
  const web_icon = ["images/html.png","images/css.png","images/js.png","images/react.png","images/angular.png","images/nodejs.png","images/vuejs.svg","images/php.png","images/ruby.png"]
  const android = ["Native Android","Kotlin","Flutter","Swift for IOS"]
  const android_icon = ["images/native.png","images/kotlin.png","images/flutter.png","images/swift.png"]
  const core = ["Operating Systems","Computer Networks", "DBMS", "OOPS"]
  const databases = ["Oracle","mongodb","firebase","My SQL"]
  const databases_icon = ["images/oracle.png","images/mongodb.jpeg","images/firebase.svg","images/mysql.png"]
  const uiux = ["Figma","Adobe XD","Illustrator","Sketch"];
  const uiux_icon = ["images/figma.png","images/xd.png","images/illustrator.png","images/sketch.png"]

  const gotolink = (e)=>{
    e.preventDeafult();
   // go to job?.link?.stringValue
    
  }
  
    return <div className='job' onClick={gotolink}>
              <a href={job?.link?.stringValue} target="_blank" style={{listStyle:"none"}}></a>
               <table>
                 <tr> <td colSpan={2} style={{textAlign:"center",backgroundImage:"linear-gradient(to right, #FAFCC2,#F6D6AD)"}}><img className='company-image' src={job?.img?.stringValue}/> {job?.company?.stringValue} </td></tr>
                 <tr> <td>Deadline <i class="far fa-calendar-alt"></i></td> <td>{job?.date?.stringValue}</td> </tr>
                 <tr> <td>Category <i class="fas fa-bars"></i></td> <td>{job?.category?.stringValue}</td> </tr>
                 <tr> <td>Location <i class="fas fa-map-marker-alt"></i></td> <td>{job?.location?.stringValue}</td> </tr>
                 <tr> <td>Salary   <i class="fas fa-rupee-sign"></i></td> <td>{job?.salary?.stringValue}</td> </tr>
                 <tr> <td>Work Experience <i class="fas fa-laptop-code"></i></td> <td>{job?.experience?.stringValue}</td> </tr>
               </table>
               <p style={{paddingLeft:"1rem"}}>Skills Required </p>
               <ul style={{paddingLeft:"1rem"}}>
                    {job?.language?.arrayValue?.values?.map((index) => <li key={index.integerValue}> <img src={languages_icon[index.integerValue]} alt='loading...'></img> {languages[index.integerValue]}</li>)}
                    {job?.android?.arrayValue?.values?.map((index) => <li key={index.integerValue}> <img src={android_icon[index.integerValue]} alt='loading...'></img> {android[index.integerValue]}</li>)}
                    {job?.database?.arrayValue?.values?.map((index) => <li key={index.integerValue}> <img src={databases_icon[index.integerValue]} alt='loading...'></img> {databases[index.integerValue]}</li>)}
                    {job?.web?.arrayValue?.values?.map((index) => <li key={index.integerValue}> <img src={web_icon[index.integerValue]} alt='loading...'></img> {web[index.integerValue]}</li>)}
                    {job?.uiux?.arrayValue?.values?.map((index) => <li key={index.integerValue}> <img src={uiux_icon[index.integerValue]} alt='loading...'></img> {uiux[index.integerValue]}</li>)}
                    {job?.core?.arrayValue?.values?.map((index) => <li key={index.integerValue}> {core[index.integerValue]}</li>)}
               </ul> 
           </div>
          ;
}

export default Job;
